import OptionsAccessManager from "../../../../../gd/manager/options-access-manager"
import FieldUser, {ADD_USER} from "../../../../generic/user/user"
import FieldConfig from "../../../../proto/field-config"
import Task from "../../../../../model2/task/task"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import ProjectUserSession from "../../../../../model2/project-user/project-user-session"
import {CompanyRole} from "../../../../../gd/const/company-role"
import FieldTaskActionRequiredUser_ConditionForm from "./render/condition"
import {FieldDropdown_filterValuesFiller} from "../../../../conditions/dropdown"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"
import {FieldGroupAllPossibleValues_Params} from "../../../../proto/types"
import {ProjectItem} from "../../../../../model2/project-item/project-item";
import {PopoverMenuItemType} from "../../../../../gd-components/popover-menu/popover-menu/const";

export default class FieldTaskActionRequiredUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                          = "Task Action Required User"
        this.icon                               = 'i5-user-action-required'

        this.noValueOptionLabel                 = 'No action required'
        this.placeholder                        = "No Action Required"

        this.isGroupByAllOptionsAvailable       = true

        this.classes.PopoverMenuScrollContainer = 'min-w-250 max-h-300'
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

        this.renderComponents.conditionForm     = FieldTaskActionRequiredUser_ConditionForm
        this.renderComponents.filterForm        = FieldTaskActionRequiredUser_ConditionForm

        this.filterValuesFiller                 = FieldDropdown_filterValuesFiller
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeActionRequired
    }

    access(model:any): 'read' | 'write' | false {

        if (_.has(model,'systemStatus')) {
            if (!gd.const.systemStatus.isOpen(model.systemStatus)) return 'read'
        }

        if (_.has(model,'projectId')) {
            // ARE you sure about it ? seems like not a good deal - check canChangeAr - this is task model
            if (!gd.ac.check.project.fullAccess(model.projectId)) return 'read'
        }

        return 'write'
    }

    getOptionsForEdit(model:Task) {

        const projectId  = model.projectId
        const taskTypeId = model.taskTypeId

        if (!projectId || !taskTypeId) {
            console.log("FieldTaskActionRequired #ERROR-FIELD-TASK-ACTION-REQUIRED-USER-45 no model passed")
            return []
        }

        this.noValueOption = OptionsAccessManager.allowNoActionRequiredUserOption(taskTypeId)

        const isNonClient = (userId: ID) => {
            const companyUser = gd.session.companyUsers.getByUserId(userId)
            return !!companyUser && companyUser.companyRole !== CompanyRole.CLIENT
        }

        const toOption = (projectUser: ProjectUserSession): Option => {
            return {
                value: projectUser.user.id,
                label: projectUser.user.name
            }
        }

        const options: Option[] = []

        if (!model.projects || model.projects.length === 0) {
            // Fallback: use projectId only
            const projectUsers = gd.session.projectUsers.filterByProject(projectId, gd.const.project.access.LIMITED)
            _.each(projectUsers.models, (pu: ProjectUserSession) => {
                if (isNonClient(pu.userId)) {
                    options.push(toOption(pu))
                }
            })
        } else {
            // Task users first
            const taskUserIds: Set<ID> = new Set()
            _.each(model.users, (taskUser: any) => {
                if (taskUser.userId && isNonClient(taskUser.userId)) {
                    const user = gd.session.users.get(taskUser.userId)
                    if (user) {
                        taskUserIds.add(taskUser.userId)
                        options.push({
                            value   : taskUser.userId,
                            label   : user.name
                        })
                    }
                }
            })

            // Collect all users from accessible projects (no duplicates)
            const projectIds: ID[] = _.map(model.projects, (projectItem: ProjectItem) => {
                return projectItem.projectId
            })
            const projectUsers = gd.session.projectUsers.filterByProjects(projectIds, gd.const.project.access.LIMITED)

            const allProjectOptions: Option[] = []
            _.each(projectUsers.models, (pu: ProjectUserSession) => {
                if (isNonClient(pu.userId) && !taskUserIds.has(pu.userId)) {
                    allProjectOptions.push(toOption(pu))
                }
            })

            if (allProjectOptions.length > 0) {
                if (options.length > 0) {
                    options.push({
                        type: PopoverMenuItemType.SEPARATOR
                    })
                }
                options.push(...allProjectOptions)
            }
        }

        // there can be no acl in model (for example RequestForm model)
        if (model.acl?.canAddUser) {
            options.push({
                value   : ADD_USER,
                label   : 'Add User',
                icon    : 'i5-plus'
            })
        }

        return options
    }


    tableCellOnValueChange = (item: ItemModelV2, value: any, manager: TasksViewManager) => {

        // Special case whn add a user
        if (value === ADD_USER) {
            item.task.addUserAsActionsRequired()
            return
        }

        item.task.actionRequiredUserId = value
        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        // Schedule depend on AR
        FieldProto_updateView(manager as TasksViewManager, this)
    }

    /** GROUP BY **/
    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        const allUserIdsSet: Set<ID | null> = new Set<ID | null>()
        allUserIdsSet.add(null)

        if (params.project) {
            _.map(gd.session.projectUsers.filterByProject(params.project.id, gd.const.project.access.LIMITED).models, projectUser => {
                if (projectUser.isTeam) return
                allUserIdsSet.add(projectUser.user.id)
            })

            _.map(params.items, (itemModel: ItemModelV2) => {
                if (itemModel.isTask && itemModel.task.actionRequiredUserId) {
                    allUserIdsSet.add(itemModel.task.actionRequiredUserId)
                }
            })
        } else {
            const projectIds: Set<ID> = new Set<ID>()

            _.map(params.items, (itemModel: ItemModelV2) => {
                if (itemModel.isTask) {
                    if (itemModel.task.actionRequiredUserId) {
                        allUserIdsSet.add(itemModel.task.actionRequiredUserId)
                    }

                    projectIds.add(itemModel.task.projectId)
                }
            })

            _.map(gd.session.projectUsers.filterByProjects([...projectIds], gd.const.project.access.LIMITED).models, projectUser => {
                if (projectUser.isTeam) return
                allUserIdsSet.add(projectUser.user.id)
            })
        }

        return _.orderBy([...allUserIdsSet],
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }
}
